import App from "@/App.vue";
import KCheckbox from "@/components/forms/inputs/Checkbox/KCheckbox.vue";
import KDateTimepicker from "@/components/forms/inputs/DateTimepicker/KDateTimepicker.vue";
import KNumber from "@/components/forms/inputs/Number/KNumber.vue";
import KRadio from "@/components/forms/inputs/Radio/KRadio.vue";
import KText from "@/components/forms/inputs/Text/KText.vue";
import AktivitetstypAutocomplete from "@/components/forms/reusables/AktivitetstypAutocomplete.vue";
import AnestesiAutocomplete from "@/components/forms/reusables/AnestesiAutocomplete.vue";
import AvtalAutocomplete from "@/components/forms/reusables/AvtalAutocomplete.vue";
import HuvuddiagnoskodAutocomplete from "@/components/forms/reusables/HuvuddiagnoskodAutocomplete.vue";
import HuvudoperationskodAutocomplete from "@/components/forms/reusables/HuvudoperationskodAutocomplete.vue";
import IdrottAutocomplete from "@/components/forms/reusables/IdrottAutocomplete.vue";
import IdrottStatistikAutocomplete from "@/components/forms/reusables/IdrottStatistikAutocomplete.vue";
import JaNejAutocomplete from "@/components/forms/reusables/JaNejAutocomplete.vue";
import KontaktorsakAutocomplete from "@/components/forms/reusables/KontaktorsakAutocomplete.vue";
import LagAutocomplete from "@/components/forms/reusables/LagAutocomplete.vue";
import OrgunitAutocomplete from "@/components/forms/reusables/OrgunitAutocomplete.vue";
import PlatsAutocomplete from "@/components/forms/reusables/PlatsAutocomplete.vue";
import PreanestesibedomningAutocomplete from "@/components/forms/reusables/PreanestesibedomningAutocomplete.vue";
import PrioritetAutocomplete from "@/components/forms/reusables/PrioritetAutocomplete.vue";
import ProfileAutocomplete from "@/components/forms/reusables/ProfileAutocomplete.vue";
import SchemaTitle from "@/components/forms/reusables/SchemaTitle.vue";
import OperationStatusAutocomplete from "@/tabs/Operation/OperationStatusAutocomplete.vue";
import BesokAutocomplete from "@/tabs/Besok/BesokAutocomplete.vue";
import TypoperationAutocomplete from "@/components/forms/reusables/TypoperationAutocomplete/TypoperationAutocomplete.vue";
import VardformAutocomplete from "@/components/forms/reusables/VardformAutocomplete.vue";
import StudieKvalitetsregisterAutocomplete from "@/components/forms/reusables/StudieKvalitetsregisterAutocomplete.vue";
import UnderlagAutocomplete from "@/components/forms/reusables/UnderlagAutocomplete.vue";
import KLabel from "@/components/forms/subComponents/Label/KLabel.vue";
import store from "@/store";
import { KlinikenToolTip } from "@/utils/tooltip";

import {
    FormulateAutocompletePlugin,
    FormulateDatePickerPlugin,
    FormulateFrasregisterPlugin,
    FormulateNowPlugin,
    FormulateNumberPlugin,
    FormulateTimePickerPlugin,
    FormulateToggleSwitchPlugin,
    FormulateVueSelectPlugin,
} from "@/vueformulate.js";
import VueFormulate from "@braid/vue-formulate";
import { sv } from "@braid/vue-formulate-i18n";
import FormulateVSelectPlugin from "@cone2875/vue-formulate-select";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import FloatingVue from "floating-vue";
import PortalVue from "portal-vue";
import PrimeAccordion from "primevue/accordion/accordion.common";
import PrimeAccordionTab from "primevue/accordiontab/accordiontab.common";
import PrimeDatepicker from "primevue/calendar/calendar.common";
import PrimeColumn from "primevue/column/column.common";
import PrimeColumnGroup from "primevue/columngroup/columngroup.common";
import PrimeVue from "primevue/config/primevue.common";
import PrimeDataTable from "primevue/datatable/datatable.common";
import "floating-vue/dist/style.css";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import PrimeDialog from "primevue/dialog/dialog.common";
import PrimeVueDropdown from "primevue/dropdown/dropdown.common";
import PrimeInputMask from "primevue/inputmask/inputmask.common";
import PrimeOverlayPanel from "primevue/overlaypanel/overlaypanel.common";
import PrimeDrawer from "primevue/sidebar/sidebar.common";
import PrimeTabPanel from "primevue/tabpanel/tabpanel.common";
import PrimeTabView from "primevue/tabview/tabview.common";
import VCalendar from "v-calendar";
import Vue from "vue";
import KGroup from "./components/forms/groups/Group/KGroup.vue";
import KRepeater from "./components/forms/groups/Repeater/KRepeater.vue";
import KAutocomplete from "./components/forms/inputs/Autocomplete/KAutocomplete.vue";
import KSection from "./components/generic/KSection.vue";
import "primeicons/primeicons.css";

new Vue({
    store,
    render: (h) => h(App),
}).$mount("#app");

// START Formulärkomponenter schema. Sätts för att kunna användas i schemas
Vue.component("KText", KText);
Vue.component("KNumber", KNumber);
Vue.component("KAutocomplete", KAutocomplete);
Vue.component("KGroup", KGroup);
Vue.component("KSection", KSection);
Vue.component("KLabel", KLabel);
Vue.component("KRepeater", KRepeater);
Vue.component("KCheckbox", KCheckbox);
Vue.component("KRadio", KRadio);
Vue.component("KDateTimepicker", KDateTimepicker);
Vue.component("SchemaTitle", SchemaTitle);
Vue.component("JaNejAutocomplete", JaNejAutocomplete);
Vue.component("IdrottAutocomplete", IdrottAutocomplete);
Vue.component("IdrottStatistikAutocomplete", IdrottStatistikAutocomplete);
Vue.component("LagAutocomplete", LagAutocomplete);
Vue.component("PlatsAutocomplete", PlatsAutocomplete);
Vue.component("UnderlagAutocomplete", UnderlagAutocomplete);
Vue.component("AktivitetstypAutocomplete", AktivitetstypAutocomplete);
Vue.component("ProfileAutocomplete", ProfileAutocomplete);
Vue.component("PreanestesibedomningAutocomplete", PreanestesibedomningAutocomplete);
Vue.component("KontaktorsakAutocomplete", KontaktorsakAutocomplete);
Vue.component("TypoperationAutocomplete", TypoperationAutocomplete);
Vue.component("HuvuddiagnoskodAutocomplete", HuvuddiagnoskodAutocomplete);
Vue.component("PrioritetAutocomplete", PrioritetAutocomplete);
Vue.component("AvtalAutocomplete", AvtalAutocomplete);
Vue.component("OrgunitAutocomplete", OrgunitAutocomplete);
Vue.component("AnestesiAutocomplete", AnestesiAutocomplete);
Vue.component("OperationStatusAutocomplete", OperationStatusAutocomplete);
Vue.component("BesokAutocomplete", BesokAutocomplete);
Vue.component("HuvudoperationskodAutocomplete", HuvudoperationskodAutocomplete);
Vue.component("VardformAutocomplete", VardformAutocomplete);
Vue.component("StudieKvalitetsregisterAutocomplete", StudieKvalitetsregisterAutocomplete);
// END Formulärkomponenter schema

// START Prime Vue
Vue.use(PrimeVue, {
    locale: {
        dayNames: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
        dayNamesShort: ["Sön.", "Mån.", "Tis.", "Ons.", "Tors.", "Fre.", "Lör."],
        dayNamesMin: ["Sö.", "Må.", "Ti.", "On.", "To.", "Fr.", "Lö."],
        monthNames: [
            "Januari",
            "Februari",
            "Mars",
            "April",
            "Maj",
            "Juni",
            "Juli",
            "Augusti",
            "September",
            "Oktober",
            "November",
            "December",
        ],
        monthNamesShort: [
            "Jan.",
            "Feb.",
            "Mar.",
            "April",
            "Maj",
            "Juni",
            "Juli",
            "Aug.",
            "Sept.",
            "Okt.",
            "Nov.",
            "Dec.",
        ],
        today: "Idag",
        weekHeader: "v.",
        firstDayOfWeek: 1,
        clear: "Rensa",
    },
});
Vue.component("PrimeDialog", PrimeDialog);
Vue.component("PrimeDrawer", PrimeDrawer);
Vue.component("PrimeOverlayPanel", PrimeOverlayPanel);
Vue.component("PrimeDatepicker", PrimeDatepicker);
Vue.component("PrimeInputMask", PrimeInputMask);
Vue.component("PrimeVueDropdown", PrimeVueDropdown);
Vue.component("PrimeDataTable", PrimeDataTable);
Vue.component("PrimeColumn", PrimeColumn);
Vue.component("PrimeColumnGroup", PrimeColumnGroup);
Vue.component("PrimeTabView", PrimeTabView);
Vue.component("PrimeTabPanel", PrimeTabPanel);
Vue.component("PrimeAccordion", PrimeAccordion);
Vue.component("PrimeAccordionTab", PrimeAccordionTab);

// END Prime Vue

Vue.use(VCalendar, {
    componentPrefix: "vc", // ...other defaults
});
Vue.use(FloatingVue, {
    themes: {
        "kliniken-tooltip": KlinikenToolTip["kliniken-tooltip"],
    },
});

Vue.use(VueFormulate, {
    plugins: [
        sv,
        FormulateVSelectPlugin,
        FormulateAutocompletePlugin,
        FormulateNumberPlugin,
        FormulateVueSelectPlugin,
        FormulateDatePickerPlugin,
        FormulateNowPlugin,
        FormulateToggleSwitchPlugin,
        FormulateTimePickerPlugin,
        FormulateFrasregisterPlugin,
    ],
    locale: "sv",
});
Vue.use(Autocomplete);
Vue.use(PortalVue);
